import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { getApiData, postApiFormData } from "../../helpers/AxiosInstance";
import { queryClient } from "../../router";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-toastify";
import useGetHook from "../../customHooks/useGetHook";
const CreateBranchComponent = loadable(
  () => import("../../components/Branch/CreateBranch")
);
const CreateBranch = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleCreate = async (values: any, setError: any) => {
    console.log(values, "values in create branch");

    const branchRes = await getApiData(`${APIS.USER_BRANCH}${values?.name}/`);

    console.log(branchRes?.data, "branchData in create branch");
    setIsLoading(true);
    const url = `${APIS.BRANCH}`;
    const formData = new FormData();
    formData.append("name", branchRes?.data?.name);
    formData.append("global_branch_id", values?.name);
    formData.append("code", values?.code);
    formData.append("company_name", values?.company_name);
    formData.append("primary_email", values?.primary_email);
    formData.append("vat_pan", values?.vat_pan);
    formData.append("landmark", values?.landmark);
    formData.append("manager", values?.manager);
    formData.append("primary_contact", values?.primary_contact);
    formData.append("secondary_contact", values?.secondary_contact);
    values?.default_rate_template
      ? formData.append("default_rate_template", values?.default_rate_template)
      : null;
    values?.warehouse ? formData.append("warehouse", values?.warehouse) : null;
    formData.append("charge_type", values?.charge_type);
    formData.append("charge", values?.charge);
    formData.append("transit_charge", values?.transit_charge);
    formData.append("is_franchise", values?.is_franchise);
    if (values?.logo && values.logo instanceof File) {
      formData.append("logo", values.logo);
    }
    values?.covered_city && values?.covered_city?.length > 0
      ? values?.covered_city?.map((item: any) =>
          formData.append("covered_city", item?.value)
        )
      : null;
    values?.service_branch && values?.service_branch?.length > 0
      ? values?.service_branch?.map((item: any) =>
          formData.append("service_branch", item?.value)
        )
      : null;

    // let formData = {
    //   ...values,
    //   covered_city: values?.covered_city
    //     ? values?.covered_city?.map((item: any) => item.value)
    //     : [],
    //   service_branch: values?.service_branch
    //     ? values?.service_branch?.map((item: any) => item.value)
    //     : [],
    // };

    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 201) {
        queryClient.refetchQueries();
        toast.success("Created Succesfully");
        navigate("/");
      } else {
        toast.error(res?.data?.message ?? "Something Went Wrong");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Branch
        </span>
      </div>
      <CreateBranchComponent
        isLoading={isLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateBranch;
